import React, { useContext } from 'react';
import { useParams } from 'react-router';

import Table from '../../../Table/Table';
import TableHasConflictTag from '../../../Table/TableAccessories/TableHasConflictTag';
import TableScroller from '../../../Table/TableScroller';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface ExitFullHistoryModalProps {
  // data: any;
}

const ExitFullHistoryModal: React.FC<ExitFullHistoryModalProps> = () => {
  const modalContext = useContext(ModalContext);
  const { driverId } = useParams();

  return (
    <ModalContainer
      width={!modalContext?.showSuccessComponent ? '867px' : undefined}
      label='View Previous Companies'
    >
      <TableScroller>
        <Table
          className='scrollable-table'
          tableHeader={{
            'Start Date': 'startDate',
            'End Date': 'endDate',
          }}
          tableDataSourceUrl={`api/v1/dispatchers/${driverId}/exit-history`}
          cellsCustomComp={{
            companyName: (
              <TableHasConflictTag
                dataKey='startDate'
                // totalConflictsKey='triggeredConflict'
                isRehiredKey='rehired'
              />
            ),
          }}
          // showPaginationControl={false}
          continuousView
        />
      </TableScroller>
    </ModalContainer>
  );
};

export default ExitFullHistoryModal;
